module.exports = __webpack_public_path__ + "static/media/banner_visitas_orientadas.91380f37.webp";